import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingOverlay, Modal } from '@pletly/ui';

import { RootStackScreenProps } from '../../../navigation/types';
import { withTranslation } from '../../../locales/hoc';
import { TeamForm, TeamFormActions, useTeamForm } from '../components/TeamForm';
import { useCreateTeam } from './components/useCreateTeam';

export type NewTeamScreenParams = {
	organisationUuid: string;
	parentTeamUuid?: string;
};

type Props = RootStackScreenProps<'NewTeam'>;

const NewTeamPage = ({
	navigation: { goBack },
	route: {
		params: { organisationUuid, parentTeamUuid },
	},
}: Props) => {
	const { t } = useTranslation();
	const { loading, submit } = useCreateTeam({
		organisationUuid,
		onTeamCreated: goBack,
		parentTeamUuid,
	});

	const formMethods = useTeamForm();

	const actions = useMemo(
		() => <TeamFormActions onCancel={goBack} onSubmit={formMethods.handleSubmit(submit)} />,
		[goBack, formMethods, submit],
	);

	return (
		<Modal
			title={parentTeamUuid ? t('teams.new-sub-team') : t('teams.new-team')}
			visible
			actions={actions}
			withOwnToast={false}
		>
			<LoadingOverlay show={loading} />
			<TeamForm formMethods={formMethods} />
		</Modal>
	);
};

export const NewTeam = withTranslation(NewTeamPage);
